<template>
  <section class="py-16 bg-gradient-to-br from-blue-400 to-blue-500">
    <div class="container mx-auto px-4">
      <h2 class="text-3xl md:text-4xl font-bold text-center mb-12 text-white">
        {{ t('feedback.title') }}
      </h2>
      
      <div class="relative overflow-hidden">
        <div 
          class="flex transition-transform duration-500 ease-in-out"
          :style="{ transform: `translateX(-${currentIndex * 100}%)` }"
        >
          <div 
            v-for="feedback in feedbacks" 
            :key="feedback.id"
            class="w-full flex-shrink-0 px-4"
          >
            <div class="bg-white_10 backdrop-blur-sm rounded-xl shadow-lg overflow-hidden w-full max-w-2xl mx-auto border border-white/20">
              <div class="p-8">
                <h3 class="text-2xl font-semibold mb-4 text-center text-white">
                  {{ feedback.name }}
                </h3>
                
                <p class="text-white/80 text-center text-lg leading-relaxed">
                  "{{ feedback.comment }}"
                </p>

                <div class="flex justify-center mt-6">
                  <div class="flex space-x-1">
                    <div 
                      v-for="star in 5" 
                      :key="star" 
                      :class="star <= (feedback.number_of_stars || 0) ? 'text-yellow-400' : 'text-white/30'" 
                      class="text-2xl"
                    >
                      ★
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Navigation Dots -->
      <div class="flex justify-center mt-8 space-x-2">
        <button 
          v-for="(_, index) in feedbacks" 
          :key="index"
          @click="setCurrentIndex(index)"
          class="w-3 h-3 rounded-full transition-all duration-300 focus:outline-none"
          :class="currentIndex === index ? 'bg-white scale-125' : 'bg-white/50 hover:bg-white/70'"
        ></button>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed, ref, onMounted } from 'vue';
import { useDataStore } from '@/stores/mainStore';
import { useI18n } from 'vue-i18n';

const store = useDataStore();
const { t } = useI18n();

const feedbacks = computed(() => store.data.feedbacks);
const currentIndex = ref(0);

const setCurrentIndex = (index) => {
  currentIndex.value = index;
};

onMounted(() => {
  store.fetchData();
});
</script>

<style scoped>
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

.bg-white_10 {
  animation: fadeIn 0.5s ease-out;
}

.max-w-2xl {
  max-width: 42rem;
}
</style>